// FullCalendar plugins throw unless core has loaded first. Components mostly
// import FullCalendar types only, which TypeScript drops, so load it here.
import '@fullcalendar/core';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
